import React, {FunctionComponent} from "react";
import {Brand, Organization, Service} from "@App/types";
import {ServiceIsVehicleReturn} from "@App/utils/conditionals/services";
import {useTranslation} from "react-i18next";
import {
    OrganizationHasSelectableBevSupport,
    OrganizationIsLeaseplanAndServiceIsAppointment,
    ServiceShouldDisplayBevOnCurrentList
} from "@App/utils/conditionals/combinations";
import {OrganizationIsLeaseplan} from "@App/utils/conditionals/organization";
import {useSelector} from "react-redux";
import {State} from "@App/state";

type BookingHeadlineProps = {
   service: Service,
    organization: Organization,
    brand?: Brand
};

export const BookingHeadline: FunctionComponent<BookingHeadlineProps> = (props: BookingHeadlineProps) => {
    const {t} = useTranslation() // i18next

    const bevSupport = useSelector((state: State) => state.filters.bevSupport)

    return (
        <div>
            <div className="text-3xl font-serif mb-1">
                {props.service && ServiceIsVehicleReturn(props.service)
                    ? t('booking.vehicleReturn.headline')
                    : t('booking.headline')
                }
            </div>
            {props.service && !OrganizationIsLeaseplan(props.organization) && (
            <div>
                <span>
                        {t('booking.subheadline', {service: props.service.pivot.display_name ?? props.service.name})}
                </span>
            {props.brand && (
                <p>
                    <span>{t('filters.brand')}</span><span>{props.brand?.name}</span>
                </p>
                )}
            {(OrganizationHasSelectableBevSupport(props.organization) && ServiceShouldDisplayBevOnCurrentList(props.service, props.organization)) && (
                <p>
                    <span>{t('filters.engineType')}</span><span dangerouslySetInnerHTML={{__html: bevSupport ? t('Elektro-/Hybridmotor') : t('Verbrennungsmotor')}}/>
                </p>
                )}
            </div>
            )}
            {OrganizationIsLeaseplanAndServiceIsAppointment(props.organization, props.service) && (
                <span className={'text-sm'}>
                        {t('booking.appointment-hint')}
                    </span>
            )}
        </div>
    );
}


